const BASE_PATH = '/static/weather'

const fillZero = (num, digitSize = 2) => {
    let s = num+"";
    while (s.length < digitSize) s = "0" + s;
    return s;
}

export const imgSrc = function (weatherObj = {}, isColorStatus = false) {
    const {status = '', type = '', inforce = ''} = weatherObj

    if(type) {
        const filename = inforce
            ? `${type}_${inforce}.svg`
            : `${type}.svg`
        
        return `${BASE_PATH}/${filename.toLowerCase()}`
    }

    if(status) {
        const filename = isColorStatus
            ? `color_${fillZero(status)}.svg`
            :`${fillZero(status)}.svg`
        
        return `${BASE_PATH}/${filename.toLowerCase()}`
    }

    return ''
}

export const imgSrcType = function (weatherObj = {}) {
    const {type = '', inforce = ''} = weatherObj
    return imgSrc({type, inforce})
}

export default {imgSrcType, imgSrc}
